import { render, staticRenderFns } from "./ScoringDefinitionDistributionChart.vue?vue&type=template&id=1e4acedc&scoped=true"
import script from "./ScoringDefinitionDistributionChart.vue?vue&type=script&lang=js"
export * from "./ScoringDefinitionDistributionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4acedc",
  null
  
)

export default component.exports